/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Map from 'scripts/models/base/map';
import List from 'scripts/models/base/list'

const Action = Map.extend({
    define: {
        type: {
            type: 'string',
            value: 'link'
        },
        title: {
            type: 'string',
            value: ''
        },
        url: {
            type: 'string',
            value: ''
        },
        target: {
            type: 'string',
            value: 'same'
        }
    }
});

const Image = Map.extend({
    define: {
        id: {
            type: 'string',
            value: ''
        },
        crop: {
            type: 'string',
            value: 'fill'
        },
        gravity: {
            type: 'string',
            value: 'center'
        }
    }
});

export const Slide = Map.extend({
    define: {
        title: {
            type: 'string',
            value: ''
        },
        caption: {
            type: 'string',
            value: ''
        },
        image: {
            Type: Image,
            Value: '*'
        },
        action: {
            Type: Action,
            Value: '*'
        }
    }
});

export const Slides = List.extend({Map: Slide}, {});
